/** Matches the check Mantine's `isEmail` validator uses, so this stays consistent with SendLink.tsx's
 *  form-level validation and the long-form-ai NarrativeSendCard's `isValidContact`. */
export const isValidEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
